import React, { useEffect } from 'react';
import { Tabs, Card, Table, Spin, Alert } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { fetchAdmins } from '../../redux/slices.js/admins/adminsSlice';
import { fetchRoles } from '../../redux/slices.js/roles/rolesSlice';

const AdminControlsPage = () => {
    const dispatch = useDispatch();
    const { items: admins, loading: adminsLoading, error: adminsError } = useSelector((state) => state.admins);
    const { items: roles, loading: rolesLoading, error: rolesError } = useSelector((state) => state.roles);

    useEffect(() => {
        dispatch(fetchAdmins());
        dispatch(fetchRoles());
    }, [dispatch]);

    const adminColumns = [
        { title: 'Name', dataIndex: 'name', key: 'name' },
        { title: 'Email', dataIndex: 'email', key: 'email' },
        { title: 'Role', dataIndex: 'role', key: 'role' },
        { title: 'Status', dataIndex: 'status', key: 'status' },
    ];

    const roleColumns = [
        { title: 'Role Name', dataIndex: 'name', key: 'name' },
        { title: 'Permissions', dataIndex: 'permissions', key: 'permissions', render: (perms) => Array.isArray(perms) ? perms.join(', ') : perms },
    ];

    return (
        <div style={{ padding: 24 }}>
            <h2>Admin Controls</h2>
            <Tabs defaultActiveKey="1" items={[
                {
                    key: '1',
                    label: 'Super Admin Users',
                    children: (
                        <Card>
                            <h3>User Management</h3>
                            {adminsLoading && <Spin tip="Loading admins..." />}
                            {adminsError && <Alert type="error" message={adminsError} showIcon style={{ marginBottom: 16 }} />}
                            <Table columns={adminColumns} dataSource={admins} rowKey="id" loading={adminsLoading} />
                        </Card>
                    )
                },
                {
                    key: '2',
                    label: 'Roles & Permissions',
                    children: (
                        <Card>
                            <h3>Role-Permission Matrix</h3>
                            {rolesLoading && <Spin tip="Loading roles..." />}
                            {rolesError && <Alert type="error" message={rolesError} showIcon style={{ marginBottom: 16 }} />}
                            <Table columns={roleColumns} dataSource={roles} rowKey="id" loading={rolesLoading} />
                        </Card>
                    )
                },
                {
                    key: '3',
                    label: 'Audit Logs',
                    children: <Card><h3>Audit Logs</h3><div style={{ height: 200, background: '#f5f5f5', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Table: Log viewer with filters</div></Card>
                },
            ]} />
        </div>
    );
};

export default AdminControlsPage; 